import bgMusic from '../assets/bgMusic2.mp3';
import clickSound from '../assets/click.mp3';
import sidebarSwitchSound from '../assets/sidebar-switch.mp3';
import sidebarLockedSound from '../assets/sidebar-locked.mp3';
import passwordFailSound from '../assets/password-failed.wav';
import successSound from '../assets/success.wav';
import signatureSound from '../assets/signature.mp3';

export type SoundName =
  | 'click'
  | 'sidebar-switch'
  | 'sidebar-locked'
  | 'select'
  | 'open'
  | 'password-fail'
  | 'success'
  | 'badge-unlock'
  | 'chat-send'
  | 'login'
  | 'game-finish'
  | 'signature';

// Map sound names to imported file paths
const soundFileMap: Record<SoundName, string> = {
  click: clickSound,
  'sidebar-switch': sidebarSwitchSound,
  'sidebar-locked': sidebarLockedSound,
  select: clickSound,
  open: sidebarSwitchSound,
  'password-fail': passwordFailSound,
  success: successSound,
  'badge-unlock': successSound,
  'chat-send': clickSound,
  login: sidebarSwitchSound,
  'game-finish': successSound,
  signature: signatureSound,
};

const sounds: Record<SoundName, HTMLAudioElement> = {} as any;

// Initialize all sounds
Object.entries(soundFileMap).forEach(([name, path]) => {
  const audio = new Audio();
  audio.src = path;
  audio.preload = 'auto';
  sounds[name as SoundName] = audio;
});

let muted = false;

// Background music element
const backgroundMusic = new Audio();
backgroundMusic.src = bgMusic;
backgroundMusic.volume = 0.3;
backgroundMusic.preload = 'auto';
backgroundMusic.loop = true;

export function playSound(name: SoundName, volume: number = 1) {
  const audio = sounds[name];
  if (!audio || muted) return;

  try {
    audio.currentTime = 0;
    audio.volume = volume;
    audio.play().catch(() => {});
  } catch {
    // Silently ignore any playback errors
  }
}

export function playBackgroundMusic() {
  if (muted) return;
  try {
    backgroundMusic.play().catch(() => {});
  } catch {
    // Silently ignore any playback errors
  }
}

export function stopBackgroundMusic() {
  try {
    backgroundMusic.pause();
    backgroundMusic.currentTime = 0;
  } catch {
    // Silently ignore any errors
  }
}

export const isMuted = () => muted;
export const toggleMute = () => {
  muted = !muted;
  if (muted) {
    stopBackgroundMusic();
  } else {
    playBackgroundMusic();
  }
};
